const img = (photoId, w = 900) =>
  `https://images.unsplash.com/${photoId}?auto=format&fit=crop&w=${w}&q=80`;

export const gbp = (n) => `£${n.toFixed(2)}`;

export const IMAGES = {
  heroMain: img("photo-1672369284630-6bcbb15febdb", 1000),
  heroSecondary: img("photo-1469406396016-013bfae5d83e", 600),
  brand: img("photo-1627764940620-90393d0e8c34", 900),
  kidsClothing: img("photo-1649547905768-1eb2e35a439d"),
  underwearEssentials: img("photo-1604482858862-1db908a653e4"),
  schoolSocks: img("photo-1585499583264-491df5142e83"),
  schoolBags: img("photo-1742986410468-0a173a45a21d"),
  swimwear: img("photo-1761523763930-81932b99b459"),
  babyWear: img("photo-1734939205476-1039385aea9f"),
  leggingsTights: img("photo-1611596534346-94839c5622ab"),
  newArrivals: img("photo-1560859259-fcf2b952aed8"),
  flamingoTee: img("photo-1528145203756-0ed7f01ee120"),
  onesies: img("photo-1569974641446-22542de88536"),
  backpackGreen: img("photo-1504424715129-fa3bcb0b8903"),
  overallBag: img("photo-1726809449053-fa7264288f5b"),
};

export const USER_PHOTOS = {
  backpack:
    "https://static.prod-images.emergentagent.com/jobs/b9477d18-67da-44b8-b3ad-b2a68286f40f/images/c35315f032817491c7a801331f98f29e87cef140da9d52be12361ca4260e5ab7.jpeg",
  romperWhite:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wear-shine-2/artifacts/76b08f211fc51b12_1770899942088.png",
  onesieYellow:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wear-shine-2/artifacts/5f47118d43256c23_1770899236161.png",
};

export const PROMO_BANNERS = [
  {
    id: "move-freely",
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_wear-shine-2/artifacts/6569a2b78c7c0cfa_file_00000000d2186246ae23e7a92752ed89.png",
    alt: "Sparkwear Move Freely — tank tops for ages 3 to 8 years",
  },
];

export const CATEGORIES = [
  { id: "kids-clothing", name: "Kids Clothing", tagline: "Play-proof tees, dresses & denim", image: IMAGES.kidsClothing, tint: "bg-blush-50" },
  { id: "underwear-essentials", name: "Underwear & Essentials", tagline: "Ultra-soft organic cotton daily wear", image: IMAGES.underwearEssentials, tint: "bg-lav-50" },
  { id: "school-socks", name: "School Socks", tagline: "Cushioned, seamless, anti-microbial", image: IMAGES.schoolSocks, tint: "bg-butter-50" },
  { id: "school-bags", name: "School Bags", tagline: "Ergonomic, light & water-resistant", image: IMAGES.schoolBags, tint: "bg-baby-50" },
  { id: "swimwear", name: "Swimwear", tagline: "UPF 50+ sun-safe suits & sets", image: IMAGES.swimwear, tint: "bg-mint-50" },
  { id: "baby-wear", name: "Baby Wear", tagline: "Hypoallergenic onesies & rompers", image: IMAGES.babyWear, tint: "bg-blush-50" },
  { id: "leggings-tights", name: "Leggings & Tights", tagline: "Stretchy, snag-proof daily layers", image: IMAGES.leggingsTights, tint: "bg-lav-50" },
  { id: "new-arrivals", name: "New Arrivals", tagline: "Fresh drops for shining bright", image: IMAGES.newArrivals, tint: "bg-butter-50" },
];

export const categoryName = (id) =>
  CATEGORIES.find((c) => c.id === id)?.name || id;

export const REVIEWS = [
  {
    parent: "Sarah J.",
    role: "Verified Parent",
    stars: 5,
    comment:
      "Sparkwear leggings are indestructible! My twins wear them non-stop on the playground and they still look brand new after dozens of washes.",
    product: "Rainbow Stretchy Leggings",
  },
  {
    parent: "Marcus V.",
    role: "Verified Dad",
    stars: 5,
    comment:
      "The school socks and backpack are top tier quality. The cushioned socks ended every complaint about scratchy shoe seams. Highly recommended!",
    product: "School Socks & WonderPack",
  },
  {
    parent: "Elena R.",
    role: "Verified Parent",
    stars: 5,
    comment:
      "The baby rompers are so soft on my newborn's delicate skin, and the pastel colours look stunning in all our family photos.",
    product: "Cloudsoft Onesie Set",
  },
];

export const SIZE_ROWS = [
  { label: "2Y", height: [86, 92], chest: 52, waist: 50, hip: 54 },
  { label: "3-4Y", height: [98, 104], chest: 56, waist: 53, hip: 59 },
  { label: "5-6Y", height: [110, 116], chest: 60, waist: 55, hip: 64 },
  { label: "7-8Y", height: [122, 128], chest: 66, waist: 58, hip: 70 },
  { label: "9-10Y", height: [134, 140], chest: 72, waist: 60, hip: 76 },
];

export const SIZE_TABS = [
  { id: "tops", label: "Tops & Dresses", cols: [["Height", "height"], ["Chest", "chest"], ["Waist", "waist"]] },
  { id: "bottoms", label: "Bottoms & Leggings", cols: [["Height", "height"], ["Waist", "waist"], ["Hip", "hip"]] },
  { id: "essentials", label: "Underwear & Socks", cols: [["Height", "height"], ["Hip", "hip"], ["Chest", "chest"]] },
];
